import { Popover, TextField, TextFieldProps } from '@mui/material';
import React, { useCallback, useId, useState } from 'react';

type TextFieldWithPopoverProps = Omit<TextFieldProps, 'children'> & {
  children?: (props: { open: boolean; handleClose: () => void }) => React.JSX.Element;
};

export const TextFieldWithPopover: React.FC<TextFieldWithPopoverProps> = ({ children, ...props }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
    },
    [setAnchorEl],
  );

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, [setAnchorEl]);

  const open = Boolean(anchorEl);
  const id = useId();

  return (
    <>
      <TextField
        id={id}
        aria-describedby={open ? id : undefined}
        inputProps={{
          'aria-expanded': open ? 'true' : 'false',
        }}
        fullWidth
        onClick={handleClick}
        variant="outlined"
        {...props}
      />
      {!props.disabled && (
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          sx={{
            '& .MuiPopover-paper': {
              padding: '0.25rem',
              width: 'auto !important',
            },
          }}
        >
          {children ? children({ open, handleClose }) : null}
        </Popover>
      )}
    </>
  );
};
